/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { SKILL_LEVELS } from '@sportninja/common/constants/skillLevels'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import {
  font,
  weightMedium,
  weightSemiBold,
  paragraphSmall,
} from 'src/components/css'

interface Props {
  value: string | null
  onChange: (next: string) => void
}

const SkillLevelChips: React.FC<Props> = ({ value, onChange }) => (
  <div>
    <div css={labelStyle}>{capitalizeWords('Skill Level')}</div>
    <div css={rowStyle}>
      {SKILL_LEVELS.map((level) => {
        const active = value === level.value
        return (
          <button
            key={level.value}
            type='button'
            aria-pressed={active}
            css={[chipStyle, active && chipActiveStyle]}
            onClick={() => onChange(level.value)}
          >
            {level.name}
          </button>
        )
      })}
    </div>
  </div>
)

export default SkillLevelChips

// ─── Styles ────────────────────────────────────────────────────────────────

const labelStyle = css`
  ${paragraphSmall}
  ${weightSemiBold}
  ${font.body}
  color: ${colors.WHITE};
  margin-bottom: 8px;
`

const rowStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

// Unselected: outlined (transparent fill + border + light text). Active:
// PRIMARY fill with dark text.
const chipStyle = css`
  ${paragraphSmall}
  ${weightMedium}
  ${font.body}
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${colors.SOFT_STEEL};
  background-color: transparent;
  color: ${colors.WHITE};
  cursor: pointer;
`

const chipActiveStyle = css`
  ${weightSemiBold}
  background-color: ${colors.PRIMARY};
  border-color: ${colors.PRIMARY};
  color: ${colors.SECONDARY_300};
`
